// this is public to the world
// so should not have any sercrets

// it should be localhost
const hostname = location.hostname

const config_dev = {
    url: `http://${hostname}:8080`,
    url_api: `http://${hostname}:8008`,
    url_dashboard: `http://${hostname}:8081`,
    email: 'getunlimitedproxy@gmail.com', // TODO: stop spam email address?
    FBAppID: '115135462537173',
    GoogleClientID:
        '822218664643-ndi73thu9g7uns23ngg8n4s8sc61duvb.apps.googleusercontent.com',
    StripePublicKey: 'pk_test_Qq6thuTtv0CObtu16tI2XHXy',
}

const config_production = {
    url: 'https://www.unlimitedproxyplan.com',
    url_api: 'https://api.unlimitedproxyplan.com',
    url_dashboard: 'https://dashboard.unlimitedproxyplan.com',
    email: 'getunlimitedproxy@gmail.com',
    FBAppID: '127923954523091',
    GoogleClientID:
        '822218664643-ndi73thu9g7uns23ngg8n4s8sc61duvb.apps.googleusercontent.com',
    StripePublicKey: 'pk_live_qghAzFodHCsnCcEPcTgzLh3p', // cop stripe
}

let config = config_production

if (hostname === 'localhost') {
    config = config_dev
}

export default config